module.exports = __webpack_public_path__ + "static/webinar2-17679c69eb2a62a5cef09c00512799a7.jpg";